import { useTranslation } from 'react-i18next';
import { DatetimePicker } from '../form-components/base-components/DateTimePicker';
import { cn } from '../utils';

interface DateFilterProps {
  onSelect: (date: Date | null) => void;
  selected: Date | null;
  disabled?: boolean;
}

export const DateFilter = ({
  onSelect,
  selected,
  disabled = false,
}: DateFilterProps) => {
  const { t } = useTranslation();

  return (
    <DatetimePicker
      buttonProps={{
        onClick: e => e.stopPropagation(),
        className: cn(
          'h-[30px] p-0 px-1 gap-1 border-0 items-center bg-white hover:brightness-100 text-primary',
          disabled && 'cursor-not-allowed opacity-60'
        ),
        disabled,
      }}
      defaultDate={null}
      closeOnSelect
      captionLayout="dropdown"
      confirmLabel={t('apply')}
      clearButtonProps={{
        label: t('clear'),
        variant: 'default',
        className: 'mb-1',
        containerClassName: 'justify-center',
      }}
      selected={selected}
      onSelect={onSelect}
    />
  );
};
